export default __webpack_public_path__ + "static/media/constructor.554e7336.png";